
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from "../Components/Header";
import '../App.css';

import { useNavigate } from "react-router-dom";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { ReactSession } from 'react-client-session';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
ReactSession.setStoreType("localStorage");

const AddProduct = () => {
  const userId=ReactSession.get("welbeingId");
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    code: '',
    product: '',
    cat: '',
    sub_id: '',
    size: '',
    price: '',
    moq: '',
    weight: '',
    gst: '',
    stock: '',
    preOrder: 'no',
    des: '',
    colors: [{ code: '#000000', name: '' }],
    size_variation: [{ size: '', amount: '' }],
    design: [''],
    images: [null, null, null, null]
  });
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');

  console.log("form data",formData);

  if(userId  <= 0 ){
      navigate('/login');
   }

  useEffect(() => { 

    axios.get('https://api.welbeing.in/admin/categories/categories/')
        .then((res) => setCategories(res.data.data)); 

    axios.get('https://api.welbeing.in/admin/categories/subcategories/')
       .then((res) => setSubCategories(res.data.data));
  }, []);

  const filteredSubCategories = subCategories.filter(
    (sub) => String(sub.cat_id) === String(selectedCategory)
  );

  console.log('filtered sub cat',filteredSubCategories)

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };



  const handleImageChange = (index, file) => {
    const updated = [...formData.images];
    updated[index] = file;
    setFormData((prev) => ({ ...prev, images: updated }));
  };

  const handleColorChange = (index, field, value) => {
    const updated = [...formData.colors];
    updated[index][field] = value;
    setFormData((prev) => ({ ...prev, colors: updated }));
  };

  const handleSizeChange = (index, field, value) => {
    const updated = [...formData.size_variation];
    updated[index][field] = value;
    setFormData((prev) => ({ ...prev, size_variation: updated }));
  };  

  const addSizeInput = () => {
  setFormData(prev => ({
    ...prev,
    size_variation: [...prev.size_variation, { size: '', amount: '' }]
  }));
};


  const addColorInput = () => {
    setFormData((prev) => ({ 
        ...prev, 
        colors: [...prev.colors, { code: '#000000', name: '' }]
     }));
  };

  const handleDesignChange = (index, value) => {
    const updated = [...formData.design];
    updated[index] = value;
    setFormData((prev) => ({ ...prev, design: updated }));
  };

  const addDesignInput = () => {
    setFormData((prev) => ({ ...prev, design: [...prev.design, ''] }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const productData = new FormData();
      const keys = ['code', 'product', 'cat', 'sub_id', 'size', 'price', 'moq', 'weight', 'gst', 'stock', 'preOrder', 'des'];
      keys.forEach((key) => productData.append(key, formData[key]));
      formData.images.forEach((img, i) => img && productData.append(`image${i + 1}`, img));

      const res = await axios.post('https://api.welbeing.in/admin/products/add-product/',
                productData);


      const product_id = res.data.data.p_id;

      for (const color of formData.colors) {
        if (!color.name) continue;
        await axios.post('https://api.welbeing.in/admin/products/add-color/', {
          p_id:product_id,
          code: color.code,
          color: color.name
        });
      }

      for (const design of formData.design) {
        if (!design) continue;
        await axios.post('https://api.welbeing.in/admin/products/add-design/', {
          p_id:product_id,
          design: design
        });
      }
      for (const sizes of formData.size_variation) {
        if(sizes.size!=''||sizes.amount!=''){
           await axios.post('https://api.welbeing.in/admin/products/add-size/', {
          p_id:product_id,
          size: sizes.size,
          amount:sizes.amount
        });
        }
        
      }

      alert('Product added successfully!');
      navigate('/products');
    } catch (err) {
      console.error(err);
      alert('Failed to submit.');
    }
  };

  return (
     <>
      <Header />
      <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
        <div class="body-wrapper">
          <div className="container-fluid">
            <div className="card bg-light-info shadow-none position-relative overflow-hidden">
              <div className="card-body px-4 py-3">
                <div className="row align-items-center">
                  <div className="col-9">
                    <h4 className="fw-semibold mb-8">Product Manage</h4>
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a className="text-muted" href="/dashboard">Dashboard</a></li>
                        <li className="breadcrumb-item active">Add Product</li>
                      </ol>
                    </nav>
                  </div>
                  <div className="col-3 text-center mb-n5">
                    <img src="/dist/images/breadcrumb/ChatBc.png" alt="breadcrumb" className="img-fluid mb-n4" />
                  </div>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="card mt-3">
                <div className="card-body">
                  <h5>Add New Product</h5>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label>Item Code</label>
                      <input name="code" className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-md-8 mb-3">
                      <label>Item Name</label>
                      <input name="product" className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Category</label>
                      <select className="form-control" value={selectedCategory}
                        onChange={(e) => {
                          const val = e.target.value;
                          setSelectedCategory(val);
                          setFormData(prev => ({ ...prev, cat: val, sub_id: '' }));
                        }}>
                        <option value="">Select Category</option>
                        {categories.map((cat) => <option key={cat.m_cate} value={cat.m_cate}>{cat.cate}</option>)}
                      </select>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Sub Category</label>
                      <select className="form-control" disabled={!selectedCategory} value={formData.sub_id} onChange={(e) => setFormData(prev => ({ ...prev, sub_id: e.target.value }))}>
                        <option value="">Select Sub Category</option>
                        {filteredSubCategories.map(sub => (
                          <option key={sub.sub_id} value={sub.sub_id}>{sub.sub_cate}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Item Size</label>
                      <input name="size" className="form-control" onChange={handleChange} />
                    </div>
                    <div className="col-md-2 mb-3"><label>Price</label><input type="number" name="price" className="form-control" onChange={handleChange} required /></div>
                    <div className="col-md-2 mb-3"><label>MOQ</label><input name="moq" className="form-control" onChange={handleChange} required /></div>
                    <div className="col-md-2 mb-3"><label>Weight</label><input name="weight" className="form-control" onChange={handleChange} /></div>
                    <div className="col-md-2 mb-3"><label>GST %</label><input type="number" name="gst" className="form-control" onChange={handleChange} required /></div>
                    <div className="col-md-2 mb-3"><label>Stock</label><input type="number" name="stock" className="form-control" onChange={handleChange} required /></div>
                    <div className="col-md-2 mb-3">
                      <label>Pre Order</label>
                      <select name="preOrder" value={formData.preOrder} className="form-control" onChange={handleChange}>

                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                    <div className="col-md-12 mb-3">
                      <label>Description</label>
                      {/* <textarea name="des" className="form-control" rows="3" onChange={handleChange}></textarea> */}
                      <CKEditor
                        editor={ClassicEditor}
                        data={formData.des}
                        onChange={(event, editor) => {
                          setFormData((prev) => ({ ...prev, des: editor.getData() }));
                        }}
                      />
                    </div>

                    {[0, 1, 2, 3].map(i => (
                      <div className="col-md-3 mb-3" key={i}>
                        <label>{`Image${i + 1}`}</label>
                        <input type="file" className="form-control" accept="image/*" onChange={(e) => handleImageChange(i, e.target.files[0])} />
                      </div>
                    ))}
                    <div className="col-md-3 mb-3">
                      <label>Add Colors</label>
                      {formData.colors.map((c, i) => (
                        <div className="form-group d-flex mt-2" key={i}>
                          <input type="color" className="form-control me-2" style={{ width: 70, height: 40, padding: 0, border: '1px solid #ccc', appearance: 'none' }} value={c.code} onChange={(e) => handleColorChange(i, 'code', e.target.value)} />
                          <input type="text" className="form-control" value={c.name} onChange={(e) => handleColorChange(i, 'name', e.target.value)} />
                        </div>
                      ))}
                      <button type="button" onClick={addColorInput} className="btn btn-primary mt-2">Add More</button>
                    </div>
                    <div className="col-md-3 mb-3">
                      <label>Add Designs</label>
                      {formData.design.map((d, i) => (
                        <input key={i} className="form-control mb-2" value={d} onChange={(e) => handleDesignChange(i, e.target.value)} />
                      ))}
                      <button type="button" onClick={addDesignInput} className="btn btn-primary mt-2">Add More</button>
                    </div>

                    <div className="col-md-4 mb-4">
                      <label>Add Size</label>
                      {formData.size_variation.map((entry, index) => (
                        <div className="d-flex gap-2 mb-2" key={index}>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Size"
                            value={entry.size}
                            onChange={(e) => handleSizeChange(index, 'size', e.target.value)}
                          />
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Amount"
                            value={entry.amount}
                            onChange={(e) => handleSizeChange(index, 'amount', e.target.value)}
                          />
                        </div>
                      ))}
                      <button type="button" onClick={addSizeInput} className="btn btn-primary mt-2">Add More</button>
                    </div>
                    <div className="col-md-12 text-center mt-4">
                      <button type="submit" className="btn btn-success w-lg-25 w-sm-100 me-2">Submit</button>
                      <button type="button" className="btn btn-danger  w-lg-25 w-sm-100" onClick={() => window.location.reload()}>Reset</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProduct;
